import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueRouter from '@/router'
import store from './store'
import ElementUI from 'element-ui'
import { MessageBox } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false

axios.interceptors.response.use((res) => {
  console.log(res)
  const code = res.data.code;
  if (code !== 'ok' && (res.data.data === '请重新登录' || res.data.data === '请重新获取')) {
    MessageBox.alert('登录超时，请重新登录', '提示', {
      confirmButtonText: '确定',
      type: 'error'
    }).then(() => {
      VueRouter.push({ name: "Login" });
    })
    return Promise.reject(res);
  }else{
    return res
  }
})
Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://39.99.35.128/bookmenu';//后端开发环境地址
// window.baseURL = axios.defaults.baseURL = 'http://121.11.98.9:8081/bookmenu';//后端开发环境地址
window.baseURL = axios.defaults.baseURL = 'http://62.234.220.177/bookmenu';//后端开发环境地址


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
